import { ErrorText } from '~/constants';
import { useOverlayContext, useStoreActions } from '~/contexts';
import { ServerError } from '~/infra/ErrorResponse';
import { handleRequest } from '~/infra/utils';
const loaderName = 'updateRelationship';
export function useUpdateRelationship() {
    const { api } = useStoreActions();
    const { startLoader, stopLoader, showErrorToast, showSuccessToast } = useOverlayContext();
    return async function updateRelationship(param) {
        let { id, version, changes, onSuccess } = param;
        startLoader(loaderName);
        const updateResult = await handleRequest(api.relationship.update(id, {
            version,
            changes
        }));
        if (!updateResult.success) {
            showErrorToast(updateResult.error.hasServerError(ServerError.MismatchingRelationshipVersion) ? ErrorText.MismatchingRelationshipVersion : ErrorText.UnexpectedErrorTryAgain, 'edit-agr-error');
            return stopLoader(loaderName);
        }
        onSuccess && await onSuccess();
        showSuccessToast('Changes saved successfully', 'edit-agr-success');
        stopLoader(loaderName);
    };
}
